
import React from "react";
import "../styles/Header.css";
import logo from "../assets/tamarac-content-no-logo.png"; 
import tamalogo from "../assets/tamarac-logo.png";

function Header() {
  return (
    <header className="app-header">
      {/* Center logo */}
      <img src={logo} alt="Contest Logo" className="center-logo" />

      {/* Top-right logo */}
      <img src={tamalogo} alt="Tamarac Logo" className="top-right-logo" />
    </header>
  );
}

export default Header;
